/**
 * App Version API — desktop app release info (public endpoint, rate-limited).
 * Used by the employee dashboard's desktop-app banner to show the download link.
 */

import apiClient from './client';

export const appVersionApi = {
  /** Latest release for a platform. Returns { version, downloadUrl, ... }. */
  async latest(platform = 'windows') {
    const response = await apiClient.get('/api/app-version/latest', { params: { platform } });
    return response.data;
  },
};

export default appVersionApi;
